import { message } from "antd";
import axios from "axios";
import APIURL from "../../../Main/apiurl";

const getAuthConfig = () => {
  const token = localStorage.getItem("user");
  if (!token) {
    localStorage.clear();
    window.location.href = "/";
    throw new Error("Authentication required");
  }
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
};
const getTrialBalance = async (data) => {
  try {
    const config = getAuthConfig();

    const response = await axios.post(`${APIURL}/trial-balance`, 
      data,
      config,
    );
    const {
      accounts = [],
      totalDebit = 0,
      totalCredit = 0,
    } = response.data.data;

    return {
      success: true,
      accounts,
      totalDebit,
      totalCredit,
    };
  } catch (error) {
    console.error("Trial Balance error:", error);
    message.error(
      error.response?.data?.message || "Failed to load Trial Balance report"
    );
    return {
      success: false,
      message:
        error.response?.data?.message || "Failed to load Trial Balance report",
    };
  }
};

export default {
  getTrialBalance,
};
